/* eslint-disable camelcase */
import {
    AddressFieldNamesOptions,
    BankAccountFieldNamesOptions,
    BasicInformationFieldNamesOptions,
    EmergencyContactsFieldNamesOptions,
    EmploymentInformationFieldNamesOptions,
    PersonalInformationFieldNamesOptions,
} from '@app/types/translatables/deafult-field-names-display.options';

/**
 * keys are in snake case because they are to match enum values in database
 */
export const DefaultFieldNames = {
    personal: {
        basic_information: BasicInformationFieldNamesOptions,
        personal_information: PersonalInformationFieldNamesOptions,
        address: AddressFieldNamesOptions,
        emergency_contacts: EmergencyContactsFieldNamesOptions,
    },
    job_and_pay: {
        employment_information: EmploymentInformationFieldNamesOptions,
        bank_account: BankAccountFieldNamesOptions,
    },
} as const;
